export default __webpack_public_path__ + "static/media/tv.c0c97668.svg";